export default class Choices {
    constructor() {
        // Choices

        const containers = document.querySelectorAll('.choice');
        if(containers.length > 0) {
            containers.forEach((container) => {
                this.selection(container);
            });
        }
    }

    selection(container) {
        const btns = container.querySelectorAll('.choice__item');
        if(btns.length > 0) {
            btns.forEach((btn) => {
                btn.addEventListener('click', () => {
                    if(container.querySelector(`[data-level="${btn.parentElement.dataset.level}"] .choice__item.js-selected`) && container.querySelector(`[data-level="${btn.parentElement.dataset.level}"] .choice__item.js-selected`) != btn) {
                        // Suppression de la classe active sur l'élément de même niveau.
                        container.querySelector(`[data-level="${btn.parentElement.dataset.level}"] .choice__item.js-selected`).classList.remove('js-selected');
                        // Suppression de l'affichage des enfants si élément pas le même que celui actif.

                        // Pour niveau -1.
                        if(container.querySelector(`[data-level="${parseInt(btn.parentElement.dataset.level, 10) + 1}"].js-visible`)) {
                            container.querySelector(`[data-level="${parseInt(btn.parentElement.dataset.level, 10) + 1}"].js-visible`).classList.remove('js-visible');
                        }
                        // Pour niveau -2.
                        if(container.querySelector(`[data-level="${parseInt(btn.parentElement.dataset.level, 10) + 2}"].js-visible`)) {
                            container.querySelector(`[data-level="${parseInt(btn.parentElement.dataset.level, 10) + 2}"].js-visible`).classList.remove('js-visible');
                        }
                        // Pour niveau -3.
                        if(container.querySelector(`[data-level="${parseInt(btn.parentElement.dataset.level, 10) + 3}"].js-visible`)) {
                            container.querySelector(`[data-level="${parseInt(btn.parentElement.dataset.level, 10) + 3}"].js-visible`).classList.remove('js-visible');
                        }
                    }
                    // Ajout de la classe active sur l'élément cliqué.
                    btn.classList.add('js-selected');

                    // Ajout de la classe visible sur l'enfant correspondant à l'élement cliqué.
                    if(container.querySelector(`[data-level="${parseInt(btn.parentElement.dataset.level, 10) + 1}"][data-id="${btn.dataset.id}"]`)) {
                        container.querySelector(`[data-level="${parseInt(btn.parentElement.dataset.level, 10) + 1}"][data-id="${btn.dataset.id}"]`).classList.add('js-visible');
                    }
                });
            });
        }
    }
}